export const GET_WEIGHT_REQUEST="GET_WEIGHT_REQUEST"
export const GET_WEIGHT_SUCCESS="GET_WEIGHT_SUCCESS"
export const GET_WEIGHT_FAILURE="GET_WEIGHT_FAILURE"